import { useCallback, useContext } from 'react';

import { OptimizelyContext } from '@optimizely/react-sdk';

import { UserContext } from 'Context/user';

import { optimizelyAttributes } from './optimizely.helper';

export const useOptimizelyTrack = () => {
  const { userState: user } = useContext(UserContext);
  const { optimizely } = useContext(OptimizelyContext);

  const optimizelyTrack = useCallback((
    event: string,
    attributes = { customId: undefined, forceDpSellerId: false } as Record<string, boolean | string | undefined>,
    properties: Record<string, string | number | undefined> | null = null,
  ) => {
    const { customId, forceDpSellerId, ...restAttributes } = attributes;

    let customUserId: string;
    if (customId) {
      customUserId = customId?.toString();
    } else if (forceDpSellerId && user?.dpSellerId) {
      customUserId = user.dpSellerId?.toString();
    }

    setTimeout(
      () => optimizely?.track(
        event,
        customUserId ?? undefined,
        optimizelyAttributes({ ...restAttributes, userId: user?.id }),
        // @ts-ignore - this is a valid property definition
        { $opt_event_properties: properties },
      ),
      0,
    );
  }, [optimizely, user?.id, user?.dpSellerId]);

  return { OPTIMIZELY_TRACK: optimizelyTrack };
};
